<template>
	 <div class="articlelist-container">
		 <div :style="{ overflow: 'hidden' }">
		   <bread-crumb :style="{ float: 'left' }" />
		  <a-button
		    type="primary"
		    shape="round"
		    icon="plus"
		    :style="{ float: 'right', marginTop: '19px' }"
		    @click="addNew"
		  >
		    新增类别
		  </a-button>
		 </div>
		<div class="global-table-container">
		  <a-table
		    :pagination="showPagination"
		    :columns="tableColumns"
		    :dataSource="tableDataList"
		    :scroll="{ x: 1200, y: 450 }"
		  >
		    <div slot="action" slot-scope="text, record">
		      <a-button
		        v-if="record.status==2"
		        type="primary"
		        shape="round"
		        size="small"
		        @click.stop="handleSetStatus(record, 1)"
		      >
		        启用
		      </a-button>
		      <a-button
		        v-if="record.status==1"
		        type="dashed"
		        shape="round"
		        size="small"
		        @click.stop="handleSetStatus(record, 2)"
		      >
		        禁用
		      </a-button>
		
		      <a-button
			   v-if="record.pid==0"
		        type="dashed"
		        shape="circle"
		        title="添加类别"
		        size="small"
				style="margin-left: 5px;"
		        @click.stop="handleAddSub(record)"
		        >子</a-button
		      >
		      <a-button
			  style="margin-left:5px;margin-right: 5px;"
		        size="small"
		        title="修改类别"
		        type="primary"
		        shape="circle"
		        icon="edit"
		        @click.stop="handleEdit(record)"
		      ></a-button>
		    </div>
		  </a-table>
		</div>
	 </div>
</template>

<script>
	import updatePanel from "@/views/ResourceManage/Papercategory/update.vue";
	var num = 0;
	var pageContext;
	export default {
	name: "Papercategory",
	data() {
	  return {
	    showPagination: false,
	    pageSearchForm: this.$form.createForm(this),
	    loadingAuthRule: false,
	    platform_type: "pl", //选择平台
	    tableColumns: [],
	    tableDataList: [],
	    rowSelection: {
	      fixed: true,
	      onChange: (selectedRowKeys, selectedRows) => {
	        console.log(selectedRowKeys);
	      },
	    },
	  };
	},
	mounted() {
	  pageContext = this;
	  pageContext.initColumns();
	  pageContext.handleChangePlatform("pl");
	},
	methods: {
	    initColumns() {
	      pageContext.tableColumns = [
	        {
	          title: "类别名称",
	          dataIndex: "name",
	          key: "name",
	        },
	        {
	          title: "操作",
	          key: "operation",
	          fixed: "right",
	          width: 230,
	          scopedSlots: { customRender: "action" },
	        },
	      ];
	    },
	    async handleChangePlatform(value) {
	      pageContext.loadingAuthRule = true;
	      pageContext.platform_type = value;
	      pageContext.tableDataList = [];
	      pageContext.refreshDataList();
	    },
	    async refreshDataList() {
	      pageContext.$http
	        .post("/paperCategory/getList", {})
	        .then(function(response) {
	          pageContext.loadingAuthRule = false;
	          if (
	            response.data.status === 1 &&
	            response.data.data.list.length > 0
	          ) {
	            pageContext.tableDataList = response.data.data.list;
	          }
	        })
	        .catch(function(error) {
	          pageContext.loadingAuthRule = false;
	          pageContext.$message.error("请求异常，请检查");
	          console.log(error);
	        });
	    },
	    addNew() {
	      pageContext.$layer.iframe({
	        content: {
	          content: updatePanel,
	          parent: this,
	          data: {
	            submitBtnLabel: "新 增",
	          },
	        },
	        area: ["500px", "300px"],
	        title: "新增试卷类别",
	        shadeClose: false,
	        cancel: () => {
	          pageContext.$message.info("操作取消！");
	        },
	      });
	    }, 
	    handleEdit(record) {
	      pageContext.$layer.iframe({
	        content: {
	          content: updatePanel,
	          parent: this,
	          data: {
	            submitBtnLabel: "保 存",
	            itemData: record,
	          },
	        },
	        area: ["500px", "300px"],
	        title: "修改试卷类别",
	        shadeClose: false,
	        cancel: () => {
	          pageContext.$message.info("操作取消！");
	        },
	      });
	    },
	    async handleSetStatus(record, status) {
	      pageContext.$http
	        .post("/paperCategory/status", {
	          id: record.id,
	          status: status,
	        })
	        .then(function(response) {
	          if (response.data.status === 1) {
	            pageContext.$message.success(response.data.msg);
	            pageContext.refreshDataList();
	          }
	        })
	        .catch(function(error) {
	          pageContext.$message.error("请求异常，请检查");
	          console.log(error);
	        });
	    },
	    handleAddSub(record) {
	      pageContext.$layer.iframe({
	        content: {
	          content: updatePanel,
	          parent: this,
	          data: {
	            submitBtnLabel: "添 加",
	            pItemData: record,
	          },
	        },
	        area: ["500px", "370px"],
	        title: "添加类别下级",
	        shadeClose: false,
	        cancel: () => {
	          pageContext.$message.info("操作取消！");
	        },
	      });
	    },
	  },
	};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-circle {
    margin: 0px 5px;
  }
}

.ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
    margin-left: 20px;
  }
</style>